import { forwardRef, HTMLAttributes, useState } from 'react'
import { SChildrenWrapper, SToggleButton } from './ShowMore.styled'
import { Icon } from 'components/icon'
import { useTranslation } from 'next-i18next'

// IMPROVE animate ShowMore using framer
// For now, we need to provide maxHeight and make sure maximum content height is not exceeding maxHeight
export const ShowMore = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement> & { disabled?: boolean; offset?: string }
>(({ offset = '10rem', disabled, children, ...rest }, ref) => {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)

  if (disabled)
    return (
      <div ref={ref} {...rest}>
        {children}
      </div>
    )

  return (
    <div ref={ref}>
      <SChildrenWrapper maxHeight={expanded ? '150rem' : offset} {...rest}>
        {children}
      </SChildrenWrapper>
      <SToggleButton expanded={expanded} onClick={() => setExpanded((e) => !e)}>
        {t(expanded ? 'common.show_less' : 'common.show_more')}
        <Icon name="ChevronDown" />
      </SToggleButton>
    </div>
  )
})
ShowMore.displayName = 'ShowMore'
